// // context/UserContext.js
// import { createContext, useContext, useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";

// const UserContext = createContext();

// export const UserProvider = ({ children }) => {
//   const [userDetails, setUserDetails] = useState(() => {
//     const saved = localStorage.getItem("userDetails");
//     return saved ? JSON.parse(saved) : undefined;
//   });

//   const [isLoggedIn, setIsLoggedIn] = useState(() => {
//     return !!(userDetails && userDetails?.token);
//   });

//   const navigate = useNavigate();

//   useEffect(() => {
//     setIsLoggedIn(!!(userDetails && userDetails?.token));
//   }, [userDetails]);

//   const logout = () => {
//     setUserDetails(undefined);
//     setIsLoggedIn(false);
//     localStorage.removeItem("userDetails");
//     localStorage.removeItem("cartItems");
//     localStorage.removeItem("token");
//     navigate("/");
//   };

//   console.log("logged in status in context", isLoggedIn);

//   return (
//     <UserContext.Provider
//       value={{ userDetails, setUserDetails, isLoggedIn, setIsLoggedIn, logout }}
//     >
//       {children}
//     </UserContext.Provider>
//   );
// };

// export const useUser = () => useContext(UserContext);

import { createContext, useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import API_URL from "../../config";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [userDetails, setUserDetails] = useState(() => {
    const saved = localStorage.getItem("userDetails");
    return saved ? JSON.parse(saved) : undefined;
  });

  const [isLoggedIn, setIsLoggedIn] = useState(() => {
    return !!(userDetails && userDetails?.token);
  });

  const navigate = useNavigate();

  useEffect(() => {
    setIsLoggedIn(!!(userDetails && userDetails?.token));
  }, [userDetails]);

  // Function to send pending blog rewards from localStorage to backend
  const sendPendingRewards = async () => {
    if (!userDetails?.token) return;

    const pendingBlogRewards =
      JSON.parse(localStorage.getItem("pendingBlogRewards")) || [];
    if (pendingBlogRewards.length === 0) return;

    try {
      const todayDate = new Date().toISOString().slice(0, 10); // YYYY-MM-DD

      // Send one by one or batch (assuming one by one here)
      await Promise.all(
        pendingBlogRewards.map(({ blogId, points }) =>
          axios.post(
            `${API_URL}/layout/add-points-to-wallet`,
            { blogId, points, readDate: todayDate },
            {
              headers: {
                Authorization: `Bearer ${userDetails.token}`,
              },
            }
          )
        )
      );

      // Clear after successful send
      localStorage.removeItem("pendingBlogRewards");
    } catch (error) {
      console.error("Error sending pending blog rewards:", error);
    }
  };

  // Trigger sendPendingRewards whenever user logs in (userDetails.token is set)
  useEffect(() => {
    if (userDetails?.token) {
      sendPendingRewards();
    }
  }, [userDetails?.token]);

  const logout = () => {
    setUserDetails(undefined);
    setIsLoggedIn(false);
    localStorage.removeItem("userDetails");
    localStorage.removeItem("cartItems");
    localStorage.removeItem("token");
    navigate("/");
  };

  console.log("logged in status in context", isLoggedIn);

  return (
    <UserContext.Provider
      value={{ userDetails, setUserDetails, isLoggedIn, setIsLoggedIn, logout }}
    >
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
